export default __webpack_public_path__ + "static/media/logo-sep.fa51d189.svg";